import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import * as urls from '../utilities/urls';
import { User, RefreshToken } from '../models/auth-user';
import { AuthRoutes } from '../utilities/routes';
import { Address, appCodeValue, UsersType } from '../utilities/common-file';
import { of, Subject } from 'rxjs';
import { EncryptStorage } from 'encrypt-storage';
import { NzModalService } from 'ng-zorro-antd';
import { SystemSearch } from '../models/System';
import { NzTableData } from '../utilities/nz-table.adapter';
import { Config } from 'src/environments/config';
export const encryptStorage = EncryptStorage('secret_key', {
  storageType: 'localStorage'
});
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private httpClient: HttpClient, private router: Router, private modalService: NzModalService) { }

  private static AUTH_USER = 'AUTH_USER';
  private static AUTH_USER_ID = 'AUTH_USER_ID';
  private static AUTH_USER_DISPLAY_NAME = 'AUTH_USER_DISPLAY_NAME';
  private static AUTH_TOKEN = 'AUTH_TOKEN';
  private static REFRESH_TOKEN = 'REFRESH_TOKEN';
  private static AUTH_USER_MERCHANT_ID = 'AUTH_USER_MERCHANT_ID';
  private static AUTH_USER_MERCHANT_NAME = 'AUTH_USER_MERCHANT_NAME';
  private static AUTH_USER_LOCATION_ID = 'AUTH_USER_LOCATION_ID';
  private static AUTH_USER_LOCATION_NAME = 'AUTH_USER_LOCATION_NAME';
  private static AUTH_USER_ROLE = 'AUTH_USER_ROLE';
  private static AUTH_USER_APPCODE = 'AUTH_USER_APPCODE';
  private static AUTH_USER_EMAIL = 'AUTH_USER_EMAIL';
  private static AUTH_USERTYPE = 'AUTH_USERTYPE';
  private static MERCHANT_DETAILS = 'MERCHANT_DETAILS';
  private static LOCATION_DETAILS = 'LOCATION_DETAILS';
  private static TERMINAL_DETAILS = 'TERMINAL_DETAILS';
  private static AUTH_USER_PASSWORD = 'AUTH_USER_PASSWORD';
  private static AUTH_USER_REMEMBERME = 'AUTH_USER_REMEMBERME';
  private static DEVICE_SIGNATURE = 'DEVICE_SIGNATURE';
  private static AUTH_USER_ROLE_ID = 'AUTH_USER_ROLE_ID';
  private static AUTH_ACCESS_MODULES = 'AUTH_ACCESS_MODULES';
  private static USER_ROLE = 'USER_ROLE';
  private static LOGIN_TIME = 'LOGIN_TIME';

  private static ACCESS_TOKEN_REMIT = 'ACCESS_TOKEN_REMIT';
  private static REFERRAL_MASTER = 'REFERRAL_MASTER'
  public loginTimeUpdated: Subject<number> = new Subject<number>();

  isRememeberMe = false;

  accessModuleList = [];
  public notify: Subject<boolean> = new Subject<boolean>(); // To emit an event on Logout

  // login(value: any): Observable<User> {
  //   return this.httpClient.post<User>(urls.AuthUrls.login, value).pipe(tap((authUser) => {
  //     if (value.rememberMe) {
  //       this.isRememeberMe = value.rememberMe;
  //       encryptStorage.clear();
  //       encryptStorage.setItem(AuthService.AUTH_USER_REMEMBERME, value.rememberMe);

  //       // To Set encrypted password in local storage if remember me is checked
  //       encryptStorage.setItem(AuthService.AUTH_USER_PASSWORD, value.password);

  //       if (authUser.message === 'OTP is already sent to your device. Please contact customer support') {
  //         this.router.navigate([AuthRoutes.otpVerify + value.email]);
  //       } else if (authUser && authUser.data && authUser.data.isOTPSent) {
  //         this.router.navigate([AuthRoutes.otpVerify + value.email]);
  //       } else {
  //         this.setUser(authUser);
  //       }
  //     } else {
  //       this.isRememeberMe = false;
  //       encryptStorage.clear();
  //       if (authUser.message === 'OTP is already sent to your device. Please contact customer support') {
  //         this.router.navigate([AuthRoutes.otpVerify + value.email]);
  //       } else if (authUser && authUser.data && authUser.data.isOTPSent) {
  //         this.router.navigate([AuthRoutes.otpVerify + value.email]);
  //       } else {
  //         this.setUser(authUser);
  //       }
  //     }
  //   }));
  // }

  // refreshTokens(): Observable<any> {
  //   return this.httpClient.get(urls.AuthUrls.refreshTokens).pipe(
  //     tap((refreshToken: any) => {
  //       this.setRefreshToken(refreshToken.data.refreshToken);
  //     }),
  //     switchMap(() => {
  //       // const value = {
  //       //   "clientId": "db2e0456-d599-4553-be1f-730e5f2ebe46",
  //       //   "clientSecret": "ee0f131d-4d2e-43f9-900d-5cdec2098b31"
  //       // }
  //       const value = {
  //         "clientId": Config.clientIdRemit,
  //         "clientSecret": Config.clientSecretRemit

  //       }
  //       return this.httpClient.post(urls.AuthUrls.authenticationRemit, value).pipe(
  //         tap((accessTokenRemit: any) => {
  //           this.setAccessTokenRemit(accessTokenRemit.data.access_token);
  //         })
  //       );
  //     })
  //   );
  // }
  // accessTokenRemit(): Observable<any> {
  //   // const value = {
  //   //   "clientId": String(Config.clientIdRemit),
  //   //   "clientSecret": String(Config.clientSecretRemit)
  //   // }
  //   const value = {
  //     "clientId": "db2e0456-d599-4553-be1f-730e5f2ebe46",
  //     "clientSecret": "ee0f131d-4d2e-43f9-900d-5cdec2098b31"
  //   }
  //   console.log("value", typeof (value.clientId))
  //   return this.httpClient.post(urls.AuthUrls.authenticationRemit, value)
  // }

  
login(value: any): Observable<any> {
  const payload = {
    email: value.email,
    password: value.password
  };

  return this.httpClient.post<any>(
    urls.AuthUrls.login,
    payload
  ).pipe(
    tap(response => {
      if (
        !response ||
        response.success !== true ||
        !response.data
      ) {
        return;
      }

      this.isRememeberMe = !!value.rememberMe;

      if (value.rememberMe) {
        encryptStorage.setItem(
          AuthService.AUTH_USER_REMEMBERME,
          true
        );

        encryptStorage.setItem(
          AuthService.AUTH_USER_EMAIL,
          value.email
        );

        encryptStorage.setItem(
          AuthService.AUTH_USER_PASSWORD,
          value.password
        );
      } else {
        encryptStorage.setItem(
          AuthService.AUTH_USER_REMEMBERME,
          false
        );

        encryptStorage.removeItem(
          AuthService.AUTH_USER_PASSWORD
        );
      }

      // Priority 1: Direct login with customToken
      if (response.data.customToken) {
        sessionStorage.removeItem('flexbiz_otp_expiry');
        sessionStorage.removeItem('flexbiz_otp_email');

        this.setUser(response);
        return;
      }

      // Priority 2: OTP login
      if (response.data.isOTPSent === true) {
        sessionStorage.setItem(
          'flexbiz_otp_expiry',
         String(Date.now() + 120000)
        );

        sessionStorage.setItem(
          'flexbiz_otp_email',
          value.email
        );
      }
    })
  );
}


  refreshTokens(): Observable<any> {
    return this.httpClient.get(urls.AuthUrls.refreshTokens).pipe(
      tap((refreshToken: any) => {
        this.setRefreshToken(refreshToken.data.refreshToken);
      }),

      switchMap((mainResponse: any) => {
        const value = {
          clientId: Config.clientIdRemit,
          clientSecret: Config.clientSecretRemit
        };

        return this.httpClient
          .post(urls.AuthUrls.authenticationRemit, value)
          .pipe(
            tap((accessTokenRemit: any) => {
              if (
                accessTokenRemit &&
                accessTokenRemit.data &&
                accessTokenRemit.data.access_token
              ) {
                this.setAccessTokenRemit(
                  accessTokenRemit.data.access_token
                );
              }
            }),

            // IMPORTANT
            // If remit auth fails, continue app login

            catchError((err) => {
              console.error('Remit token failed', err);
              // optional
              this.setAccessTokenRemit(null);
              // continue login flow
              return of(null);

            }),
            // return original response
            map(() => mainResponse)
          );

      })

    );
  }

  
refreshCustomTokens(): Observable<any> {
  return this.httpClient.post<any>(
    urls.AuthUrls.refreshCustomToken,
    {
      refreshToken: this.getRefreshToken()
    }
  ).pipe(
    tap(response => {
      const token = response &&
        response.data &&
        response.data.refresh_token;

      if (!token) {
        throw new Error('Refresh token missing in response');
      }

      this.setAuthToken(token);
    })
  );
}


 
refreshRemitTokens(): Observable<any> {
  return this.httpClient.post<any>(
    urls.AuthUrls.authenticationRemit,
    {
      clientId: Config.clientIdRemit,
      clientSecret: Config.clientSecretRemit
    }
  ).pipe(
    tap(response => {
      const token = response &&
        response.data &&
        response.data.access_token;

      if (!token) {
        throw new Error('Remit access token missing');
      }

      this.setAccessTokenRemit(token);
    })
  );
}



  // verifyOTP(value): Observable<any> {
  //   return this.httpClient.post<User>(urls.AuthUrls.verifyOTP, value).pipe(tap((authUser) => {
  //     this.setUser(authUser);
  //   }));
  // }
  // resendOTP(value) {
  //   return this.httpClient.post(urls.AuthUrls.resendOTP, value);
  // }

  verifyOTP(value: { email: string; otp: string }): Observable<any> {
    return this.httpClient.post<any>(
      urls.AuthUrls.verifyOTP,
      {
        email: value.email,
        otp: value.otp
      }
    ).pipe(
      tap(response => {
        if (
          response &&
          response.success === true &&
          response.data &&
          response.data.customToken
        ) {
          this.setUser(response);
        }
      })
    );
  }

  resendOTP(email: string): Observable<any> {
    return this.httpClient.post<any>(
      urls.AuthUrls.resendOTP,
      { email }
    );
  }

  forgetPassword(value) {
    return this.httpClient.post(urls.AuthUrls.forgetPassword, value);
  }
  resetPassword(value) {
    return this.httpClient.post(urls.AuthUrls.resetPassword, value);
  }
  getSystemWithLimit(tableData: NzTableData<SystemSearch, any>) {
    const value = {
      appCode: tableData.search.appCode,
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex,
      name: tableData.search.name,
      displayName: tableData.search.displayName
    };
    return this.httpClient.post(urls.systemUrls.list, value);
  }
  validateToken(value) {
    return this.httpClient.post(urls.AuthUrls.tokenValidate, value);
  }
  private setUser(authUser) {
    // Clear only previous account context, preserving remember-me settings.
    [
      AuthService.AUTH_USER_MERCHANT_ID, AuthService.AUTH_USER_MERCHANT_NAME,
      AuthService.MERCHANT_DETAILS, AuthService.AUTH_USER_LOCATION_ID,
      AuthService.AUTH_USER_LOCATION_NAME, AuthService.LOCATION_DETAILS,
      AuthService.TERMINAL_DETAILS, AuthService.AUTH_USERTYPE,
      AuthService.USER_ROLE, AuthService.REFERRAL_MASTER,
      AuthService.AUTH_ACCESS_MODULES, AuthService.REFRESH_TOKEN,
      AuthService.ACCESS_TOKEN_REMIT
    ].forEach(key => encryptStorage.removeItem(key));
    this.accessModuleList = [];
    encryptStorage.setItem(AuthService.LOGIN_TIME, Date.now());
    encryptStorage.setItem(AuthService.AUTH_USER, JSON.stringify(authUser));
    encryptStorage.setItem(AuthService.AUTH_USER_ID, authUser.data.id);
    encryptStorage.setItem(AuthService.AUTH_USER_EMAIL, authUser.data.email);
    encryptStorage.setItem(AuthService.AUTH_USER_DISPLAY_NAME, authUser.data.displayName);
    encryptStorage.setItem(AuthService.AUTH_USER_ROLE, authUser.data.role);
    encryptStorage.setItem(AuthService.AUTH_USER_APPCODE, authUser.data.appCode);
    // encryptStorage.setItem(AuthService.AUTH_USERTYPE, authUser.data.buUserType);
    // encryptStorage.setItem(AuthService.USER_ROLE, authUser.data.privilege)

    if (authUser.data.buUserType != null) {
      encryptStorage.setItem(
        AuthService.AUTH_USERTYPE,
        authUser.data.buUserType
      );
    }

    if (authUser.data.privilege != null) {
      encryptStorage.setItem(
        AuthService.USER_ROLE,
        authUser.data.privilege
      );
    }

    if (authUser.data.businessReferralMaster != null) {
      encryptStorage.setItem(AuthService.REFERRAL_MASTER, authUser.data.businessReferralMaster);
    }

    this.setAuthToken(authUser.data.customToken);
    let appCode = '';
    appCode = encryptStorage.getItem(AuthService.AUTH_USER_APPCODE);
    if (appCode === appCodeValue.all) {
      encryptStorage.setItem(AuthService.AUTH_USER_APPCODE, '');
    }
    if (authUser.data.merchant) {
      encryptStorage.setItem(AuthService.AUTH_USER_MERCHANT_ID, authUser.data.merchant.id);
      encryptStorage.setItem(AuthService.AUTH_USER_MERCHANT_NAME, authUser.data.merchant.name);
      encryptStorage.setItem(AuthService.MERCHANT_DETAILS, authUser.data.merchant);
    }
    if (authUser && authUser.data && authUser.data.roleId) {
      encryptStorage.setItem(AuthService.AUTH_USER_ROLE_ID, authUser.data.roleId);
    }
    // Set Location & Terminal for filters dropdown

    if (authUser.data && authUser.data.role && authUser.data.role === UsersType.merchantUser) {
      if (authUser.data.locations) {
        encryptStorage.setItem(AuthService.LOCATION_DETAILS, authUser.data.locations);
      }
      if (authUser.data.terminals) {
        encryptStorage.setItem(AuthService.TERMINAL_DETAILS, authUser.data.terminals);
      }
    }
    if (authUser.data && authUser.data.role && authUser.data.role !== UsersType.merchantUser) {
      if (authUser.data.location) {
        encryptStorage.setItem(AuthService.AUTH_USER_LOCATION_ID, authUser.data.location.id);
        encryptStorage.setItem(AuthService.AUTH_USER_LOCATION_NAME, authUser.data.location.name);
        const locationDetails = [authUser.data.location];
        encryptStorage.setItem(AuthService.LOCATION_DETAILS, locationDetails);
      }
      if (authUser.data.terminal) {
        const terminalDetails = [authUser.data.terminal];
        encryptStorage.setItem(AuthService.TERMINAL_DETAILS, terminalDetails);
      }
    }
  }
  setDeviceSignature(value) {
    localStorage.setItem(AuthService.DEVICE_SIGNATURE, value);
  }
  getDeviceSignature() {
    return localStorage.getItem(AuthService.DEVICE_SIGNATURE);
  }
  getPassword(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_PASSWORD);
  }
  getRememberMe() {
    return encryptStorage.getItem(AuthService.AUTH_USER_REMEMBERME);
  }
  getUserId(): number {
    return Number(encryptStorage.getItem(AuthService.AUTH_USER_ID));
  }
  getDisplayName(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_DISPLAY_NAME);
  }
  setDisplayName(name: string) {
    encryptStorage.setItem(AuthService.AUTH_USER_DISPLAY_NAME, name);
  }
  getEmail(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_EMAIL);
  }
  getRole(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_ROLE);
  }
  getUserType(): string {
    return encryptStorage.getItem(AuthService.AUTH_USERTYPE);
  }
  getUserRole(): string {
    return encryptStorage.getItem(AuthService.USER_ROLE)
  }
  getMerchantId(): any {
    // tslint:disable-next-line: radix
    return parseInt(encryptStorage.getItem(AuthService.AUTH_USER_MERCHANT_ID));
  }
  getLocationId(): any {
    // tslint:disable-next-line: radix
    return parseInt(encryptStorage.getItem(AuthService.AUTH_USER_LOCATION_ID));
  }
  getMerchantDetails(): any {
    return encryptStorage.getItem(AuthService.MERCHANT_DETAILS);
  }
  getLocationDetails(): any {
    return encryptStorage.getItem(AuthService.LOCATION_DETAILS);
  }
  getTerminalDetails(): any {
    return encryptStorage.getItem(AuthService.TERMINAL_DETAILS);
  }
  getRoleAccessModule(): string {
    return encryptStorage.getItem(AuthService.AUTH_ACCESS_MODULES);
  }
  getRoleId(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_ROLE_ID);
  }
  setRoleAccessModule(type: string) {
    encryptStorage.setItem(AuthService.AUTH_ACCESS_MODULES, type);
  }
  getAuthData(): any {
    return encryptStorage.getItem(AuthService.AUTH_USER);
  }

  getAppCode() {
    let appCode = encryptStorage.getItem(AuthService.AUTH_USER_APPCODE);
    if (appCode && typeof appCode === 'string' || appCode == '') {
      return encryptStorage.getItem(AuthService.AUTH_USER_APPCODE);
    } else {
      return encryptStorage.getItem(AuthService.AUTH_USER_APPCODE).toString();
    }
  }
  // To get address dynamically.
  getAddressName(data) {
    let address = Address[data.appCode] ? Address[data.appCode] : Address[''];
    return address;
  }
  private setAuthToken(token: string) {
    encryptStorage.setItem(AuthService.AUTH_TOKEN, token);
  }

  getAuthToken(): string {
    return encryptStorage.getItem(AuthService.AUTH_TOKEN);
  }
  getReferralUser(): string {
    return encryptStorage.getItem(AuthService.REFERRAL_MASTER);
  }


  private setRefreshToken(token: string) {
    encryptStorage.setItem(AuthService.REFRESH_TOKEN, token);
  }
  getRefreshToken(): string {
    return encryptStorage.getItem(AuthService.REFRESH_TOKEN);
  }
  setAccessTokenRemit(token: string) {
    encryptStorage.setItem(AuthService.ACCESS_TOKEN_REMIT, token);
  }
  getAccessTokenRemit(): string {
    return encryptStorage.getItem(AuthService.ACCESS_TOKEN_REMIT);
  }


  // This function will return true When Logout is detected
  onNotify(event) {
    return this.notify.next(true);
  }
  // For Login User Type based options show / Hide

  showOptionsBasedOnUserType() {
    const userType = this.getRole();
    if (userType === UsersType.locationUser || userType === UsersType.locationManager) {
      return false;
    } else {
      return true;
    }
  }

  
logout(): Observable<any> {
  const userEmail = this.getEmail();
  const userPassword = this.getPassword();
  const rememberMe = this.getRememberMe();

  return this.httpClient.get<User>(urls.AuthUrls.logout).pipe(
    catchError(error => {
      // Even if the server-side logout fails,
      // remove the local authenticated session.
      return of({
        success: false,
        message: 'Signed out locally.'
      });
    }),
    tap(() => {
      encryptStorage.clear();

      sessionStorage.removeItem('flexbiz_otp_expiry');
      sessionStorage.removeItem('flexbiz_otp_email');

      if (rememberMe) {
        encryptStorage.setItem(
          AuthService.AUTH_USER_REMEMBERME,
          true
        );

        encryptStorage.setItem(
          AuthService.AUTH_USER_EMAIL,
          userEmail
        );

        if (userPassword) {
          encryptStorage.setItem(
            AuthService.AUTH_USER_PASSWORD,
            userPassword
          );
        }
      }

      this.router.navigate([AuthRoutes.login]);
    })
  );
}

  public isAuthenticated(): boolean {
    const token = encryptStorage.getItem(AuthService.AUTH_TOKEN);
    return token !== null;
  }
  showMessage() {
    this.modalService.error({
      nzTitle: 'Your login access might be revoked. Please use valid credentials to log in or contact support for assistance.',
      nzOkText: 'OK',
      nzOkType: 'danger',
      nzOnOk: () => this.modalService.closeAll()
    });
  }
  getUserGuide() {
    var params = {
      "appCode": this.getAppCode() === '' ? '*' : this.getAppCode(),
      "portalType": "merchantboard",
    }
    return this.httpClient.post(urls.userGuide.list, params);
  }
  getAttachment(value) {
    return this.httpClient.post(urls.AttachmentUrls.listAttachments, value);
  }

  getDecryptModules() {
    if (this.getRoleId()) {
      const accessModules: any = this.getRoleAccessModule();
      this.accessModuleList = accessModules;
    } else {
      this.accessModuleList = [];
    }
  }
  clearDecryptModules() {
    this.accessModuleList = [];
  }
  getModuleGroupAndModuleAccess(moduleName: string, groupName: string) {
    if (!this.accessModuleList || this.accessModuleList.length === 0) {
      return false;
    }

    if (!moduleName || !groupName) {
      return false;
    }

    const index = this.accessModuleList.findIndex(M =>
      M &&
      M.backofficeModule &&
      M.backofficeModule.moduleName &&
      M.backofficeModule.groupName &&
      moduleName &&
      groupName &&
      M.backofficeModule.moduleName.toUpperCase() === moduleName.toUpperCase() &&
      M.backofficeModule.groupName.toUpperCase() === groupName.toUpperCase()
    );

    return index !== -1;
  }


  getModuleGroup(groupName: string) {
    if (!this.accessModuleList || this.accessModuleList.length === 0) {
      return false;
    }

    const index = this.accessModuleList.findIndex(M =>
      M &&
      M.backofficeModule &&
      M.backofficeModule.groupName &&
      groupName &&
      M.backofficeModule.groupName.toUpperCase() === groupName.toUpperCase()
    );

    return index !== -1;
  }

  getLoginTime() {
    return encryptStorage.getItem(AuthService.LOGIN_TIME);
  }
  setLoginTime(): void {
    const currentTime = Date.now();

    encryptStorage.setItem(AuthService.LOGIN_TIME, currentTime);
    this.loginTimeUpdated.next(currentTime);
  }
}
